<button [disabled]="disable" class="button is-rounded {{ modifier }} is-{{ type }}">
  <ng-content></ng-content>
</button>